<script setup>
import { computed, inject } from 'vue';
import SubHead from '@/components/result/MLSRD-2026/SubHead.vue';
import SubArea from '@/components/result/MLSRD-2026/SubArea.vue';
import AnswerRates from '@/components/result/MLSRD-2026/AnswerRates.vue';
import SuggestionList from '@/components/result/MLSRD-2026/SuggestionList.vue'; 

import numeracyGraph02 from '@/assets/images/result/numeracy_graph_02.png';

// 부모에서 주입받은 데이터
const studentData = inject('studentData');
const loading = inject('loading');

const pagetype = "numeracy";
const region = "seoul";
const userRole = "student";

// 학교급과 학년에 따른 gradeLevel 설정
const gradeLevel = computed(() => {
    if (!studentData.value) return 'E_4';
    
    const schoolType = studentData.value.schul_type;
    const grade = parseInt(studentData.value.grade_code);
    
    if (schoolType === 'E') {
        return grade === 4 ? 'E_4' : 'E_6';
    } else if (schoolType === 'M') {
        return 'M_2';
    } else if (schoolType === 'H') {
        return 'H_1';
    }
    
    return 'E_4'; // 기본값
});

// 기존 gradeGroup도 유지 (하위 호환성)
const gradeGroup = computed(() => {
    if (!studentData.value) return 'elementary';
    
    const schoolType = studentData.value.school_type;
    return schoolType === 'E' ? 'elementary' : 'secondary';
});

// 수리력 영역별 정답률 (mathsub1~4: 수와 양, 모양과 측정, 규칙과 관계, 자료와 불확실성)
const ourClassPercentages = computed(() => {
    if (!studentData.value) return [-1, -1, -1, -1];
    
    return [
        parseInt(studentData.value.matsub1_rate) || -1,  // 수와 양
        parseInt(studentData.value.matsub2_rate) || -1,  // 모양과 측정
        parseInt(studentData.value.matsub3_rate) || -1,  // 규칙과 관계
        parseInt(studentData.value.matsub4_rate) || -1   // 자료와 불확실성
    ];
});

// 전체 정답률 (mathsub1_total_rate~4)
const overallPercentages = computed(() => {
    if (!studentData.value) return [0, 0, 0, 0];
    
    return [
        parseInt(studentData.value.matsub1_total_rate) || 0,  // 수와 양
        parseInt(studentData.value.matsub2_total_rate) || 0,  // 모양과 측정
        parseInt(studentData.value.matsub3_total_rate) || 0,  // 규칙과 관계
        parseInt(studentData.value.matsub4_total_rate) || 0   // 자료와 불확실성
    ];
});

// 각 영역별 안전도 (안전, 경계, 주의)
const subAreaLevels = computed(() => {
    if (!studentData.value) return ['', '', '', ''];
    
    return [
        studentData.value.matsub1_level || '',  // 수와 양
        studentData.value.matsub2_level || '',  // 모양과 측정
        studentData.value.matsub3_level || '',  // 규칙과 관계
        studentData.value.matsub4_level || ''   // 자료와 불확실성
    ];
});

</script>

<template lang="">
    <div class="slide-inner">
        <div class="content">    
            <SubHead :type="pagetype" :region="region" :hideTitleBox="true" />
             <div class="card-wrap">
                <SubArea 
                    :type="pagetype" 
                    :region="region" 
                    :userRole="userRole" 
                    :isStudent="true"
                    :subAreaLevels="subAreaLevels"
                />
                <AnswerRates
                    :type="pagetype" 
                    :graph-src="literacyGraph02"
                    :our-class-percentages="ourClassPercentages"
                    :overall-percentages="overallPercentages"
                    :isStudent="true"
                    :userRole="userRole"
                />
                <SuggestionList
                    :type="pagetype"
                    :region="region"
                    :gradeGroup="gradeGroup"
                    :gradeLevel="gradeLevel"
                    :isStudent="true"
                />
            </div>
        </div>
    </div>
</template>